import React from "react"
import {
  Col,
  Container,
  Row,
} from 'design-react-kit';
import { getPath } from "../../services/api"
import * as Constants from '../../utils/constants'
import PhoneIcon from "./PhoneIcon";
import PhoneIconGreen from "./PhoneIconGreen";

export const SibaFooter = () => {
  return (
    <footer className="it-footer bottom">
      <div className="it-footer-main siba-header">
        <Container>
          <section>
            <Row className="justify-content-md-left">
              <Col sm={6} xs={9} style={{textAlign:"left", color: "black"}}>
                    <strong>REGIONE LIGURIA</strong> &nbsp;Partita Iva 00849050109
                    <br/>
                    <address>Piazza De Ferrari 1, 16121 Genova</address>
                    
                    {/* STALIGK-822
                        ICO SVG COMMENTATE <PhoneIcon/><a className="phone-number" title="Componi il numero di telefono..." href="tel:+39-010-54851">centralino +39 010 54851</a>
                    <br/>
                    <PhoneIconGreen className="greenyellow"/><a className="phone-number" title="Componi il numero di telefono..." href="tel:800-445-445">numero verde 800 445 445</a>
                    */}
                    <a className="phone-number" title="Componi il numero di telefono..." href="tel:+39-010-54851">centralino +39 010 54851</a>
                    <br/>
                    <a className="phone-number" title="Componi il numero di telefono..." href="tel:800-445-445">numero verde 800 445 445</a>
                    <br/>
                    <span className="phone-number">fax +39 010 5488742</span>
              </Col>
              <Col sm={4} xs={1}></Col>
              <Col sm={2} xs={2}>
                    <a href={getPath() + Constants.URL_PRIVACY_POLICY_PUBLIC} style={{color:"black"}}>Privacy Policy</a>
              </Col>
            </Row>
          </section>
        </Container>
      </div>
    </footer>
  );
}

export default SibaFooter;